import { BaseModel } from './common'

export enum NotificationEnum {
  MINT_COMPLETED = 'mint_completed',
  ARP_FAVORITED = 'arp_favorited',
  PARENT_ARP_FAVORITED = 'parent_arp_favorited',
  ARP_USED = 'arp_used'
}

interface BaseNotificationData {
  type: NotificationEnum
}

export interface IMintCompletedNotification extends BaseNotificationData {
  type: NotificationEnum.MINT_COMPLETED
  arpId: number
}

export interface IArpFavoritedNotification extends BaseNotificationData {
  type: NotificationEnum.ARP_FAVORITED
  arpId: number
  triggeredByWalletAddress: string
}

export interface IParentArpFavoritedNotification extends BaseNotificationData {
  type: NotificationEnum.PARENT_ARP_FAVORITED
  arpId: number
  triggeredByWalletAddress: string
  parentArpId: number
}

export interface IArpUsedNotification extends BaseNotificationData {
  type: NotificationEnum.ARP_USED
  arpId: number
  triggeredByWalletAddress: string
  triggeredByArpId: number
}

export type INotificationUnion =
  | IMintCompletedNotification
  | IArpFavoritedNotification
  | IParentArpFavoritedNotification
  | IArpUsedNotification

export interface NotificationModel extends BaseModel {
  readAt?: string
  data: INotificationUnion
  notifiableId: number
}
